import {INotification, INotificationState} from "./Helper";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {getNotifications, markAllNotificationsAsRead} from "./ActionCreators";

const initialValue: INotificationState = {
    loading: false,
    items: [],
    markAllAsReadLoading: false
}

const notificationSlice = createSlice({
    name: SliceNames.NOTIFICATION,
    initialState: initialValue,
    reducers: {
        readNotification: (state, action: PayloadAction<string>) => {
            state.items = [...state.items].map((n) => {
                if (n.id === action.payload) {
                    return {...n, read: true}
                }
                return n
            })
        },
    },
    extraReducers: builder => {
        builder.addCase(
            getNotifications.pending, (state) => {
                state.loading = true
            })
            .addCase(
                getNotifications.fulfilled, (state, action: PayloadAction<INotification[]>) => {
                    state.loading = false
                    state.items = action.payload
                })
            .addCase(
                getNotifications.rejected, (state) => {
                    state.items = []
                    state.loading = false
                })
            .addCase(
                markAllNotificationsAsRead.pending, (state) => {
                    state.markAllAsReadLoading = true
                })
            .addCase(
                markAllNotificationsAsRead.fulfilled, (state) => {
                    state.items = [...state.items].map((n) => (
                        {
                            ...n,
                            read: true
                        }
                    ))
                    state.markAllAsReadLoading = false
                })
            .addCase(
                markAllNotificationsAsRead.rejected, (state) => {
                    state.markAllAsReadLoading = false
                })
    }
})

export default notificationSlice.reducer

export const {readNotification} = notificationSlice.actions